import { Component } from '@angular/core';

@Component({
  selector: 'app-config-delete-jurisdiction',
  templateUrl: './config-delete-jurisdiction.component.html',
  styleUrls: ['./config-delete-jurisdiction.component.scss']
})
export class ConfigDeleteJurisdictionComponent {
}

